/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  BUTTON_FORMAT_TRANSPARENT,
  BUTTON_THEME_DEFAULT,
  ButtonFormat,
  ButtonFormatTransparent,
  ButtonTheme,
  ButtonThemeDefault,
} from '../Button';
import { SdsDivProps } from '../Component.props';
import { DROPDOWN_POSITION_RIGHT, DropdownItemData, DropdownPositionType } from '../Dropdown';
import { TooltipProps } from '../Tooltip';

/**
 * The props for `<ActionMenu />`.
 */
export interface ActionMenuProps extends SdsDivProps {
  /**
   * The aria label for the launch button.
   */
  buttonLabel: string;

  /**
   * The format of the launch button.
   */
  buttonFormat?: ButtonFormat;

  /**
   * Custom content for the launch button.
   */
  buttonCustomContent?: JSX.Element;

  /**
   * The theme of the launch button.
   */
  buttonTheme?: ButtonTheme;

  /**
   * The Dropdown position.
   */
  dropdownPosition?: DropdownPositionType;

  /**
   * The list of action items.
   */
  itemList: Array<DropdownItemData>;

  /**
   * Unique identifier for the dropdown section.
   */
  sectionKey: string;

  /**
   * Tooltip for the button
   */
  tooltip?: TooltipProps;
}

/**
 * The default prop values for `<ActionMenu />`.
 */
export const actionMenuDefaults = {
  buttonFormat: BUTTON_FORMAT_TRANSPARENT as ButtonFormatTransparent,
  buttonLabel: `Choose an action`,
  buttonTheme: BUTTON_THEME_DEFAULT as ButtonThemeDefault,
  dropdownPosition: DROPDOWN_POSITION_RIGHT as DropdownPositionType,
  itemList: [],
};
